import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslationModule } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';

import {
  AlarmToastComponent,
  TipToastComponent,
  AmberAlertToastComponent,
  SnChatToastComponent,
  ScheduledMaintenanceToastComponent,
  CadHighPriorityToastComponent,
  AxonAlertsToastComponent,
} from './components';
import { AxonUsherToastComponent } from './components';
import { ViAlprExportToastComponent } from './components/vi-alpr-export-toast/vi-alpr-export-toast.component';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    // Material
    MatMenuModule,
    MatTooltipModule,
    // Libs
    SnButtonModule,
    SnIconModule,
    MatButtonModule,
    MatIconModule,
    TranslationModule,
  ],
  declarations: [
    AlarmToastComponent,
    TipToastComponent,
    AmberAlertToastComponent,
    SnChatToastComponent,
    ScheduledMaintenanceToastComponent,
    CadHighPriorityToastComponent,
    AxonUsherToastComponent,
    AxonAlertsToastComponent,
    ViAlprExportToastComponent,
  ],
  exports: [
    AlarmToastComponent,
    TipToastComponent,
    AmberAlertToastComponent,
    SnChatToastComponent,
    ScheduledMaintenanceToastComponent,
  ],
})
export class SnToastsModule {}
